<script>
	import { Icon, DialogNew, notifications } from '@shopboxai/sb-portal-components';
	import { deleteToken } from '../../utils/api.js';
	import { createEventDispatcher } from 'svelte';
	const dispatch = createEventDispatcher();

	export let data = {};

	const submitDelete = async () => {
		try {
			notifications.info('Deleting token...', 2000);
			await deleteToken(data.id);
			notifications.success('Token deleted', 2000);
		} catch (error) {
			notifications.danger('Soemthing went wrong', 2000);
		} finally {
			dispatch('complete');
		}
	};
</script>

<DialogNew on:submit={submitDelete} on:close>
	<button slot="toggle">
		<Icon name="delete" />
	</button>
	<div slot="header">Delete</div>
	<button class="primary" slot="primary-action"> Delete </button>
	<div slot="content">
		Are you sure you want to delete the token
		<span>
			{data.name}
		</span>
		?
	</div>
</DialogNew>

<style>
	span {
		font-weight: 700;
	}
</style>
